/**
 * Recent Customers Component
 * - Displays list of recently registered users
 * - Shows user avatars, names, and join dates
 * - Links to individual user profiles
 */

import React from "react";
import { useNavigate } from "react-router-dom";
import { IoIosArrowForward } from "react-icons/io";

function Avatar({ name }) {
  const letter = name?.charAt(0) || "?";
  return (
    <div className="flex h-9 w-9 items-center justify-center rounded-full bg-gray-100 text-sm font-semibold text-gray-700">
      {letter}
    </div>
  );
}

export default function RecentCustomers({ recentUsers }) {
  const navigate = useNavigate();

  const people = recentUsers && recentUsers.length > 0
    ? recentUsers.map(user => ({
        name: user.name || 'N/A',
        email: user.email || 'N/A',
        city: 'N/A', // API doesn't provide city info
        amount: 'N/A' // API doesn't provide amount info
      }))
    : [];

  if (!recentUsers || recentUsers.length === 0) {
    return (
      <div className="w-full border-gray-300 border p-3 sm:p-4 py-4 sm:py-5 rounded-lg">
        <div className="mb-4">
          <h3 className="text-sm sm:text-base font-semibold text-gray-900">Recent Customers</h3>
          <p className="mt-1 text-xs text-gray-500">Lorem ipsum dolor sit amet.</p>
        </div>
        <div className="text-center py-8 text-gray-500">
          No recent customers available
        </div>
      </div>
    );
  }
  return (
    <div className="w-full border-gray-300 border p-3 sm:p-4 py-4 sm:py-5 rounded-lg">
      <div className="mb-4">
        <h3 className="text-sm sm:text-base font-semibold text-gray-900">Recent Customers</h3>
        <p className="mt-1 text-xs text-gray-500">Lorem ipsum dolor sit amet.</p>
      </div>

      <ul className="divide-y divide-gray-100">
        {people.map((p, i) => (
          <li key={i} className="flex items-center justify-between gap-2 sm:gap-3 py-3">
            <div className="flex items-center gap-2 sm:gap-3 min-w-0 flex-1">
              <Avatar name={p.name} />
              <div className="min-w-0 flex-1">
                <div className="text-xs sm:text-sm font-medium text-gray-900 truncate">{p.name}</div>
                <div className="text-xs text-gray-500 truncate">{p.email}</div>
              </div>
            </div>
            <div className="text-right flex-shrink-0">
              <div className="text-xs sm:text-sm font-semibold text-gray-900">{p.amount}</div>
              <div className="text-xs text-gray-400">{p.city}</div>
            </div>
          </li>
        ))}
      </ul>

      <button
        onClick={() => navigate('/swift-app/admin/users')}
        className="mt-4 text-xs sm:text-sm font-medium text-blue-600 hover:underline flex items-center gap-1"
      >
        SEE ALL CUSTOMERS <IoIosArrowForward className="w-3 h-3 sm:w-4 sm:h-4" />
      </button>
    </div>
  );
}
